export default "__VITE_ASSET__IOYULLLF__"